import { DocumentType } from '@/types/schema';

export const TRUST_QUESTIONS = [
  'Is this a grantor trust?',
  'Who are the fiduciaries?',
  'How does the trust distribute?',
];

export const WILL_QUESTIONS = [
  'Is this a pourover will?',
  'Creates a testamentary trust?',
  'Any specific bequests?',
];

export const HEALTH_CARE_QUESTIONS = [
  'Who is appointed?',
  'What powers are granted?',
  'When was this executed?',
];

export const BUSINESS_QUESTIONS = [
  'How is ownership structured?',
  'How can ownership transfer?',
  'What is the business purpose?',
];

export const OTHER_QUESTIONS = [
  'Explain key details',
  'Define document purpose',
  'Who is given authority or benefits?',
];

export const TRUST_DOCUMENT_TYPES = new Set<DocumentType>([
  DocumentType.SignedTrustDocument,
  DocumentType.TrustAmendment,
  DocumentType.TrustRelatedDocument,
]);

export const WILL_DOCUMENT_TYPES = new Set<DocumentType>([
  DocumentType.Will,
  DocumentType.WillCodicil,
]);

export const HEALTH_CARE_DOCUMENT_TYPES = new Set<DocumentType>([
  DocumentType.HealthcareProxy,
  DocumentType.PowerOfAttorney,
  DocumentType.LivingWill,
]);

export const BUSINESS_DOCUMENT_TYPES = new Set<DocumentType>([
  DocumentType.LlcAgreement,
  DocumentType.LlcAgreementAmendment,
  DocumentType.OperatingAgreement,
  DocumentType.OperatingAgreementAmendment,
  DocumentType.PartnershipAgreement,
  DocumentType.PartnershipAgreementAmendment,
  DocumentType.ShareholdersAgreement,
]);
